import _ from 'lodash'
import type { IWarmupData } from '@wix/thunderbolt-symbols'
import type { AppsWarmupData } from 'feature-window-wix-code-sdk'
import type { BootstrapData } from '../../types'
import type { IViewerHandlers } from '../types'
import { BOOTSTRAP_DATA, VIEWER_HANDLERS, WARMUP_DATA } from './moduleNames'
import { createPromise } from '@wix/thunderbolt-commons'

const WarmupData = ({ viewerHandlers }: IViewerHandlers, bootstrapData: BootstrapData): IWarmupData => {
	const {
		window: { isSSR },
		bi: {
			pageData: { pageNumber },
		},
	} = bootstrapData.platformEnvData

	const { promise: warmupDataPromise, resolver: warmupDataResolver } = createPromise()

	// Init empty appsWarmupData and reassign it when the data is available, to avoid awaiting it.
	let appsWarmupData: AppsWarmupData = {}
	if (!isSSR && pageNumber === 1) {
		viewerHandlers.onAppsWarmupDataReady((warmupData: AppsWarmupData) => {
			appsWarmupData = warmupData
			warmupDataResolver()
		})
	}

	return {
		waitForWarmupData(appDefinitionId, key) {
			if (isSSR) {
				console.warn('getting warmup data is not supported on the backend')
				return Promise.resolve()
			}
			if (pageNumber !== 1) {
				console.warn('Warmup data is onl available on the first page load')
				return Promise.resolve()
			}
			return warmupDataPromise.then(() => _.get(appsWarmupData, [appDefinitionId, key]))
		},
		getAppData(appDefinitionId, key) {
			if (isSSR) {
				console.warn('getting warmup data is not supported on the backend')
				return null
			}
			return _.get(appsWarmupData, [appDefinitionId, key])
		},
		setAppData(appDefinitionId, key, data) {
			if (!isSSR) {
				console.warn('setting warmup data is not supported in the browser')
				return
			}
			viewerHandlers.setAppWarmupData({ appDefinitionId, key, data })
		},
	}
}

export default {
	factory: WarmupData,
	deps: [VIEWER_HANDLERS, BOOTSTRAP_DATA],
	name: WARMUP_DATA,
}
